module.exports = __webpack_public_path__ + "static/img/icon11.b1e37df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon11.png
// module id = gImq
// module chunks = 0